var path = 'components/material-icon-select.tpl.html';
var html = " <div class=tb-material-icon-select layout=row> <md-icon class=material-icons ng-click=openIconDialog($event)>{{icon}}</md-icon> <md-input-container flex> <label translate>icon.icon</label> <input ng-mousedown=openIconDialog($event) ng-model=icon> </md-input-container> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/material-icon-select.tpl.html
// module id = 1330
// module chunks = 1